import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { QuizEditorQuizQuestionFragmentDoc } from './QuizEditorQuizQuestion';
export type QuizEditorCacheUpdaterFragment = { __typename: 'QuizContentType', id: string, versionStatus?: Types.ResourceStatusEnum | null, quizQuestions: Array<{ id: string, order: number, questionId: string }>, questions: Array<{ id: string }> };


export type QuizEditorCacheUpdaterFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const QuizEditorCacheUpdaterFragmentDoc = /*#__PURE__*/ gql`
    fragment QuizEditorCacheUpdater on QuizContentType {
  id
  versionStatus
  quizQuestions {
    ...QuizEditorQuizQuestion
  }
  questions(versionStatus: DRAFT) {
    id
  }
  __typename
}
    `;